import { DotLottiePlayer } from '@dotlottie/react-player';
import '@dotlottie/react-player/dist/index.css';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

/** Kept outside either report implementation so legacy reports can be removed independently. */
export const AiAnimationContainer = styled.div`
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  & svg > g > g > path[fill='rgb(255,255,255)'] {
    opacity: 0;
  }
  @media (prefers-reduced-motion: reduce) {
    display: none;
  }
`;

export function AiSummaryLoading() {
  const { t } = useTranslation('SurveySummary');
  return (
    <div role="status">
      <AiAnimationContainer aria-hidden="true">
        <DotLottiePlayer src="/animations/aiLoading.lottie" autoplay loop />
      </AiAnimationContainer>
      <p style={{ textAlign: 'center' }}>
        {t('loadingDescription1')}
        <br />
        {t('loadingDescription2')}
      </p>
    </div>
  );
}
